import { wrapContained as withStyle, stylesIf } from 'utils/styles'

export default withStyle((props) => {
  const { type, dashed, collapseMargins } = props

  return `
    && { 
      &.ant-divider-horizontal {
        display: block;
        clear: both;
        width: 100%;
        min-width: 100%;
        height: 1px;
        margin: ${collapseMargins ? '0' : '24px 0'};
      }
      
      ${stylesIf(
        type === 'vertical' && dashed,
        `
        border-left: 1px dashed #e8e8e8;
      `
      )}
    }
  `
})
